import React from 'react';
import { observer } from 'mobx-react';
import EmptyState from '../../../components/EmptyState';
var ViewChatDenied = function ViewChatDenied(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Chat Disabled' : _ref$title,
    _ref$iconHidden = _ref.iconHidden,
    iconHidden = _ref$iconHidden === void 0 ? false : _ref$iconHidden,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(EmptyState, {
    icon: !iconHidden && /*#__PURE__*/React.createElement("img", {
      src: require('./icon.svg'),
      alt: "Chat Disabled graphic",
      style: {
        width: 'auto',
        height: 150
      }
    }),
    title: title
  }, children || /*#__PURE__*/React.createElement(React.Fragment, null, "Please contact an administrator to allow chat permissions"));
};
export default observer(ViewChatDenied);
//# sourceMappingURL=index.js.map
